import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["finchProviderType"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.element.querySelector(
      'input[name*="organization_type"]:checked',
    )
    const isFinch = selected?.value === "finch"
    this.finchProviderTypeTarget.style.display = isFinch ? "" : "none"
  }
}
